import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import EducationMiddleware from './../../../modules/education/middleware'
import BooksMiddleware from './../../../modules/books/middleware'
import FilterBooks from './../../../components/Filter/FilterBooks'
import AdvancedFilterContainer from './../Advanced'

const mapStateToProps = ({education, books}) => ({
  subjects: education.subjects,
  segments: education.segments,
  authors: education.authors,
  publishers: education.publishers,
  filter: books.filter
})

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    fetchSegments: (page) => EducationMiddleware.fetchSegments(),
    fetchSubjects: (page) => EducationMiddleware.fetchSubjects(),
    fetchAuthors: (page) => EducationMiddleware.fetchAuthors(),
    fetchPublishers: (page) => EducationMiddleware.fetchPublishers(),
    changeFilter: (type, currentIds) => BooksMiddleware.changeFilter(type, currentIds)
  }, dispatch)
}

class FilterBooksContainer extends Component {
  componentDidMount () {
    const {
      fetchSegments,
      fetchSubjects,
      fetchAuthors,
      fetchPublishers
    } = this.props
    
    fetchSegments()
    fetchSubjects()
    fetchAuthors()
    fetchPublishers()
  }
  render () {
    const {
      segments,
      subjects,
      authors,
      publishers,
      changeFilter,
      filter
    } = this.props

    return (
      <div>
        <FilterBooks
          segments={segments}
          subjects={subjects}
          authors={authors}
          publishers={publishers}
          changeFilter={changeFilter}
        />
        <AdvancedFilterContainer
          changeHandler={changeFilter}
          onuFilterDependence={filter.onuGroups}
        />
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FilterBooksContainer)



// WEBPACK FOOTER //
// ./src/containers/FilterContainers/Books/index.js